exports.components = {
  "component---src-components-layout-layout-jsx": () => import("./../../../src/components/layout/layout.jsx" /* webpackChunkName: "component---src-components-layout-layout-jsx" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-ssr-jsx": () => import("./../../../src/pages/ssr.jsx" /* webpackChunkName: "component---src-pages-ssr-jsx" */),
  "component---src-templates-demo-jsx": () => import("./../../../src/templates/demo.jsx" /* webpackChunkName: "component---src-templates-demo-jsx" */)
}

